module.exports = new __parcel__URL__("spray.073459f3.png").toString();